import classNames from 'classnames';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useSearchParams } from 'react-router-dom';

import { SEARCH_PARAMS } from 'constants/search-params';
import { LEGACY_MAX_WIDTH_TABLET_MEDIUM } from 'style/constants';

import './styles.less';

interface Props {
  children: React.ReactNode;
}

function BackOfficeDrawerPusher({ children }: Props): JSX.Element {
  const isTabletOrMobile = useMediaQuery({ maxWidth: LEGACY_MAX_WIDTH_TABLET_MEDIUM });
  const [searchParams] = useSearchParams();

  const drawer = searchParams.get(SEARCH_PARAMS.DRAWER.key);
  const selectedEnterprise = searchParams.get(SEARCH_PARAMS.BACK_OFFICE.SELECTED_ENTERPRISE);
  const selectedDevice = searchParams.get(SEARCH_PARAMS.BACK_OFFICE.SELECTED_DEVICE);
  const selectedUser = searchParams.get(SEARCH_PARAMS.BACK_OFFICE.SELECTED_USER);
  const invitationEmail = searchParams.get(SEARCH_PARAMS.INVITATION_EMAIL);

  return (
    <div
      className={classNames('BackOfficeDrawerPusher', {
        open:
          !isTabletOrMobile &&
          (drawer ||
            selectedEnterprise ||
            selectedDevice ||
            selectedUser ||
            invitationEmail)
      })}
    >
      {children}
    </div>
  );
}

export default BackOfficeDrawerPusher;
